@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

$offset: calc(100%);
$gap: 5px;

.cc-tooltip {
    align-items: center;
    display: inline-flex;
    position: relative;

    &--pos-top {
        .cc-tooltip__content {
            bottom: $offset;
            justify-content: center;
            width: 100%;

            &-popup {
                margin-bottom: $gap;
            }
        }
    }
    &--pos-top-left {
        .cc-tooltip__content {
            bottom: $offset;
            justify-content: left;

            &-popup {
                margin-bottom: $gap;
            }
        }
    }
    &--pos-top-right {
        .cc-tooltip__content {
            bottom: $offset;
            right: 0;

            &-popup {
                margin-bottom: $gap;
            }
        }
    }
    &--pos-bottom-left {
        .cc-tooltip__content {
            top: $offset;
            justify-content: left;

            &-popup {
                margin-top: $gap;
            }
        }
    }
    &--pos-bottom {
        .cc-tooltip__content {
            top: $offset;
            justify-content: center;
            width: 100%;

            &-popup {
                margin-top: $gap;
            }
        }
    }
    &--pos-bottom-right {
        .cc-tooltip__content {
            right: 0;
            top: $offset;

            &-popup {
                margin-top: $gap;
            }
        }
    }
    &--pos-left {
        .cc-tooltip__content {
            align-items: center;
            bottom: 0;
            height: 100%;
            right: $offset;
            width: $gap;

            &-popup {
                margin-right: $gap;
                position: absolute;
                right: 0;
            }
        }
    }
    &--pos-left-bottom {
        flex-direction: column;
        justify-content: flex-end;

        .cc-tooltip__content {
            bottom: 0;
            height: 100%;
            right: $offset;
            width: $gap;

            &-popup {
                bottom: 0;
                margin-right: $gap;
                position: absolute;
                right: 0;
            }
        }
    }
    &--pos-left-top {
        flex-direction: column;
        justify-content: flex-start;

        .cc-tooltip__content {
            bottom: 0;
            height: 100%;
            right: $offset;
            width: $gap;

            &-popup {
                margin-right: $gap;
                position: absolute;
                right: 0;
            }
        }
    }
    &--pos-right {
        .cc-tooltip__content {
            align-items: center;
            bottom: 0;
            height: 100%;
            left: $offset;
            width: $gap;

            &-popup {
                left: 0;
                margin-left: $gap;
                position: absolute;
            }
        }
    }
    &--pos-right-top {
        flex-direction: column;
        justify-content: flex-start;

        .cc-tooltip__content {
            bottom: 0;
            height: 100%;
            left: $offset;
            width: $gap;

            &-popup {
                left: 0;
                margin-left: $gap;
                position: absolute;
            }
        }
    }
    &--pos-right-bottom {
        flex-direction: column;
        justify-content: flex-end;
        .cc-tooltip__content {
            bottom: 0;
            height: 100%;
            left: $offset;
            width: $gap;

            &-popup {
                bottom: 0;
                left: 0;
                margin-left: $gap;
                position: absolute;
            }
        }
    }

    &--expanded {
        display: flex;
    }

    &--pointer {
        cursor: pointer;
    }

    &:hover {
        .cc-tooltip__content {
            display: flex;
        }
    }

    &__content {
        display: none;
        overflow: visible;
        position: absolute;
        z-index: 99;

        &--animated {
            animation: fadeIn 0.3s;
        }

        &-popup {
            font-size: 0.8em;
            padding: 3px 6px;
            display: inline-block;
            white-space: nowrap;

            &--bordered {
                border: 2px white solid;
            }

            &--set-width {
                width: 200px;
                white-space: unset;

                &-wide {
                    width: 350px;
                }
            }

            &--centered {
                text-align: center;
            }

            &--theme-default {
                @apply bg-blue-200 text-black;
            }

            &--theme-action {
                @apply bg-blue-700 text-white;
            }

            &--theme-danger {
                @apply bg-red-500 text-white;
            }

            &--theme-alert {
                @apply bg-yellow-200 text-yellow-700;
            }

            &--theme-plain {
                @apply bg-white text-black;
            }

            &--theme-success {
                @apply bg-green-200 text-black;
            }
        }
    }

    &__text {
        font-weight: normal;
        margin-bottom: 10px;

        &:last-of-type {
            margin-bottom: 0;
        }

        &--emphasized {
            font-weight: bold;
        }

        &--blue {
            @apply text-blue-700;
        }
    }

    &__text-group {
        margin-bottom: 10px;
        &--divided {
            padding-bottom: 10px;
            border-bottom: 1px dashed gray;
        }

        &:last-child {
            margin-bottom: 0;
        }
    }
}
